import React, {useEffect} from 'react' 
import Aos from 'aos';
import "aos/dist/aos.css";

import {Visa, Study, Hostel, Immigraton, Travel, Team, DegreeAttestation } from '../../../Shared/Images/image';
import { Link } from 'react-router-dom';

const Offer = props =>{
    useEffect(()=>{
        Aos.init({duration: 2000})
    }, [])  
    return(
        <section>
            <div className="Offer-section">
                    <div className="py-5" data-aos="fade-down">
                        <div className="mx-width">
                            <h2 className="heading2 font-weight-bold  text-center">What we <span className="text-color2">Offer</span></h2>
                            <div className="Offer-cities pt-5">
                                <div className="row justify-content-center">
                                    <div className="col-lg-3">  
                                        <Link to="/contactus" className="hgh-link">
                                            <div className="img-hgh">
                                                <img src={ Visa } alt="VisaImage" width="75" />
                                            </div>
                                            <h1 className="heading">Visa</h1>
                                        </Link>
                                    </div>  
                                    <div className="col-lg-3">  
                                        <Link to="/" className="hgh-link">
                                            <div className="img-hgh">
                                                <img src={Study} alt="studyImage" width="120" />
                                            </div> 
                                            <h1 className="heading">Study</h1>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3">  
                                        <Link to="/contactus" className="hgh-link">
                                            <div className="img-hgh">
                                                <img src={ Hostel } alt="hostelImage" width="90" />
                                            </div>                                 
                                            <h1 className="heading">Hostel</h1>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3">  
                                        <Link to="https://www.facebook.com/deltaglobalconsultants/" className="hgh-link">
                                            <div className="img-hgh">
                                                <img src={Team} alt="ConferenceImage" width="100" />
                                            </div>  
                                            <h1 className="heading">International</h1>
                                            <h1 className="heading">Conference</h1>
                                        </Link>   
                                    </div>                            
                                </div>
                            </div>
                        </div>
                        <div className="ms-width">
                            <div className="Offer-cities pt-5">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4">  
                                        <Link to="/contactus" className="hgh-link">
                                            <div className="img-hgh">
                                                <img src={Travel} alt="Travel" width="95" />
                                            </div>                                
                                            <h1 className="heading">Travel</h1>
                                        </Link> 
                                    </div>
                                    <div className="col-lg-4">  
                                        <Link to="/contactus" className="hgh-link">
                                            <div className="img-hgh"><img src={Immigraton} alt="ImmigrationImage" width="100" /></div>                               
                                            <h1 className="heading">Immigration</h1> 
                                        </Link> 
                                        
                                    </div>
                                    <div className="col-lg-4">  
                                       <Link to="/services/degreeattestation" className="hgh-link">
                                            <div className="img-hgh"><img src={ DegreeAttestation } alt="DegreeAttestationImage" width="90" /></div>
                                            <h1 className="heading">Degree</h1>
                                            <h1 className="heading">Attestation</h1>
                                       </Link>
                                    </div>                 
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </section>
    )
}

export default Offer;